import { EnumAmazonMarketplace, EnumAmazonProduct } from './amazon.constants';

/** Existing BSR estimates, shared by the chart and server. These are estimates, not sales records. */
export function estimateDemandSales(design: { product: string; marketplace: string }, bsr: number): number {
	const clothing = [EnumAmazonProduct.Shirt, EnumAmazonProduct.Hoodie];
	const accessories = [EnumAmazonProduct.PopSocket, EnumAmazonProduct.PhoneCase, EnumAmazonProduct.ToteBag,
		EnumAmazonProduct.Tumbler, EnumAmazonProduct.CeramicMug];
	const product = design.product as EnumAmazonProduct;
	let coefficients: number[][] | null = null;
	if (product === EnumAmazonProduct.KDP) {
		coefficients = [[312025.5, -0.827626], [191893.4, -0.7699062], [20355, -0.754107]];
	} else if (clothing.includes(product)) {
		coefficients = [[894982.4, -0.8718843], [10978.98, -0.5987387], [8355.059, -0.559088]];
	} else if (accessories.includes(product)) {
		coefficients = [[826495, -0.885235], [184026.4, -0.8313879], [313260, -1.005964]];
	}
	if (!coefficients || !Number.isFinite(bsr) || bsr <= 0 || bsr >= 99999999) return Number.NaN;
	const market = design.marketplace as EnumAmazonMarketplace;
	let multiplier = 1;
	if (market === EnumAmazonMarketplace.FR) multiplier = 0.75;
	else if (market === EnumAmazonMarketplace.ES) multiplier = 0.55;
	else if (market === EnumAmazonMarketplace.IT) multiplier = 0.45;
	if (![EnumAmazonMarketplace.COM, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.CO_UK,
		EnumAmazonMarketplace.FR, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.IT].includes(market as EnumAmazonMarketplace)) return Number.NaN;
	const [scale, power] = coefficients[market === EnumAmazonMarketplace.COM ? 0 : market === EnumAmazonMarketplace.CO_UK ? 2 : 1];
	return scale * Math.pow(bsr, power) * multiplier;
}
